import moment from 'moment';

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
const today = () => moment.utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
const days = Array.from(Array(56).keys()).reverse();

const metrics = () => [
  {
    name: 'page_views',
    title: 'Page Views',
    description:
      "The number of times a Page's profile has been viewed by logged in and logged out people.",
  },
  {
    name: 'page_likes',
    title: 'Page Likes',
    description: 'The number of people who have liked your page',
  },
  {
    name: 'reach',
    title: 'Reach',
    description: 'The number of people who had any posts from your Page enter their screen.',
  },
  {
    name: 'post_engagements',
    title: 'Post Engagements',
    description:
      'The number of times people have engaged with your posts through likes, comments and shares and more.',
  },
];

const getInsightOverviewData = () =>
  metrics().reduce((acc, x) => {
    const values = days.map(i => ({
      value: getRandomNumber(0, 10),
      date: today()
        .subtract(i, 'days')
        .format('MMM D'),
      end_date: today()
        .subtract(i, 'days')
        .unix(),
    }));

    acc[x.name] = x;
    acc[x.name].values = values;
    acc[x.name].value = values.reduce((ac, a) => ac + a.value, 0);
    acc[x.name].difference = getRandomNumber(100, 400) - acc[x.name].value;

    return acc;
  }, {});

export default {
  getInsightOverviewData,
};



// WEBPACK FOOTER //
// ./src/store/modules/social/mockUtils.js